import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-DrawToolbar',
	column: 'c-DrawToolbar__column',
	group: 'c-DrawToolbar__group',
	insightButton: 'c-DrawToolbar__insightButton',
};

export const Style = {
	[CSS.container]: {
		position: 'absolute',
		top: 0,
		right: 0,
		display: 'flex',
		height: 0,
	},
	[CSS.column]: {
		display: 'flex',
		'flex-direction': 'column',
	},
	[CSS.group]: {
		display: 'flex',
		'flex-direction': 'column',
		'align-items': 'center',
		'flex-shrink': 0,
		'box-shadow': DefaultTheme.shadow.box.dp2,
		overflow: 'hidden',
		'margin-top': DefaultTheme.space(2),
		'margin-right': DefaultTheme.space(2),
		'border-radius': '8px',
		'& > button': {
			border: 'none',
			'box-shadow': 'none',
			'border-radius': '0px',
			margin: '0px',
		},
		'& > button:not(.hidden):first-child': {
			'border-top-left-radius': '8px',
			'border-top-right-radius': '8px',
		},
		'& > button:not(.hidden):last-child': {
			'border-bottom-left-radius': '8px',
			'border-bottom-right-radius': '8px',
		},
	},
};
